import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';

export type SignOutClickSource = 'hamburger_menu' | 'header';

const isHeaderSignOut = (source: SignOutClickSource): boolean =>
  source === 'header';

/** Sign out — mobile hamburger sidebar vs desktop header dropdown. */
export const trackSignOutClick = (
  source: SignOutClickSource = 'hamburger_menu',
  page_path?: string
): void => {
  const category = isHeaderSignOut(source)
    ? PULSE_CLICK_CATEGORY.HEADER
    : PULSE_CLICK_CATEGORY.HAMBURGER_MENU;
  const view_id = isHeaderSignOut(source) ? PULSE_CLICK_CATEGORY.HEADER : 'hamburger_menu';
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;

  trackPulseClick({
    category,
    action: PULSE_CLICK_ACTION.TAP_SIGN_OUT,
    label: null,
    view_id,
    page_id: category,
    page_path: path,
  });
};
